import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      d: "M6.497 2.303a50 50 0 0 1 8.36-.222c.308.017.447.39.23.605L14.053 3.72a.57.57 0 0 1-.42.165 48 48 0 0 0-6.929.265c-1.32.148-2.376 1.188-2.53 2.491a46 46 0 0 0 0 10.717c.153 1.303 1.21 2.344 2.53 2.491 3.49.39 7.103.39 10.594 0 1.32-.147 2.377-1.188 2.53-2.49.283-2.428.374-4.872.27-7.31a.57.57 0 0 1 .167-.425l1.025-1.025a.355.355 0 0 1 .605.227c.194 2.915.121 5.843-.22 8.748-.254 2.176-2.005 3.88-4.171 4.122a50 50 0 0 1-11.006 0c-2.166-.242-3.917-1.946-4.172-4.122a48 48 0 0 1 0-11.148c.255-2.177 2.006-3.88 4.172-4.123m11.835-.354c.244 0 .479.097.651.27l2.828 2.828a.923.923 0 0 1 0 1.301l-9.192 9.193a.9.9 0 0 1-.418.239l-3.829 1a.92.92 0 0 1-1.122-1.123l1-3.828a.95.95 0 0 1 .197-.381l.008-.009 9.227-9.22a.92.92 0 0 1 .65-.27M9.967 12.535l-.54 2.067 2.067-.54 8.365-8.365-1.527-1.527z"
    }, null, -1)
  ])))
}
export default { render: render }